import globalStore from '$$store/main';
import projectsModel from '$$projectModel';

function onCalendarIntegrationUpdated(event) {
  if (+GT.user.id === +event.data.userId) {
    const project = projectsModel.getItem(event.data.projects[0]);
    const data = {
      ...event.data,
      projects: [{ name: project.name, ganttId: project.gantt_id }],
    };

    if (event.data.type === 'google') {
      globalStore.commit('integrationGoogle/updateLink', { id: event.data.id, data });
    } else {
      globalStore.commit('integrationOutlook/updateLink', { id: event.data.id, data });
    }
  }
}

export default onCalendarIntegrationUpdated;
